import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getMsgAttachList = async (msgId) => {
  return await request.get(
    `/Question/note_attachments/${msgId}`,
    {},
    'При загрузке вложений для сообщения произошла ошибка',
    []
  );
};

const useQuestionMsgAttachList = (msgId, options) =>
  useQuery(
    questionsQueryKeys.questionMsgAttachList(msgId),
    () => getMsgAttachList(msgId),
    options
  );

export default useQuestionMsgAttachList;
